import React from "react";
import Header from "./Header/Header";
import Banner from "./Banner/Banner";
import About from "./About/About";
import How from "./How/How";
import Why from "./Why/Why";
import Luck from "./Luck/Luck";
import Usecases from "./Usecases/Usecases";
import Luckify from "./Luckify/Luckify";
import Footer from "./Footer/Footer";

const Landing = () => {
  return (
    <>
      <Header />
      <Banner />
      <About />
      <How />
      <Why />
      <Luck />
      <Usecases />
      <Luckify />
      <Footer />
    </>
  );
};

export default Landing;
